
window.startSlackWebhookVerification = function () {
  window.Swal.fire({
    html: '<br/><br/><br/><div class="spinner-border" role="status"></div><br/><br/><br/><p class="text-center">One moment - we\'re just checking this Webhook URL...</p><br/><br/><br/>',
    showConfirmButton: false,
    allowEscapeKey: false,
    allowOutsideClick: false,
    allowEnterKey: false
  })

  setTimeout(function () {
    window._syncSlackWebhookWithApi()
  }, 250)
}

window._syncSlackWebhookWithApi = function () {
  var webhookURL = $('#txtWebhookUrl').val() || ''
  $.post({
    url: '/integrations/slack/verify',
    data: {
      webhookURL: webhookURL
    },
    dataType: 'json'
  })
  .done(function (data) {
    data = _.defaultTo(data, {})
    const isSuccess = _.defaultTo(data.success, false)
    const errorMsg = _.defaultTo(data.error, '') || 'An unknown error occured.'
    if (isSuccess) {
      const challengeToken = _.defaultTo(data.challengeToken, '')
      window.__challenge = challengeToken
      setTimeout(function () {
        window._showSlackVerificationDialogue(null)
      }, 1000)
    } else {
      setTimeout(function () {
        Swal.fire({ title: 'Connection Error', text: errorMsg, icon: 'error' })
      }, 1000)
    }
  })
  .fail(function (xhr, status, err) {
    Swal.fire({ title: 'Connection Error', text: 'Error connecting to the AugerConnect server.', icon: 'error' })
  })
}

window._showSlackVerificationDialogue = function (err) {
  var message = 'That Webhook looks good to us!'
  var icon = 'question'
  if (err) {
    icon = 'error'
    message = '😭 Oh no, that verification did not work.'
  }
  message += '\n\nWe\'ve sent a verification code to your channel, paste it below to complete the setup process.'
  setTimeout(function () {
    Swal.fire({
      title: 'Verification',
      text: message,
      icon: icon,
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showConfirmButton: true,
      showLoaderOnConfirm: true,
      allowEscapeKey: false,
      allowOutsideClick: false,
      allowEnterKey: false,
      willClose: false,
      showCancelButton: true,
      footer: 'Verification codes allow us to check that everything is working properly.',
      preConfirm: (input) => {
        var code = input.trim().toLowerCase().replace(/[^0-9a-z]/gi, '')
        console.debug(code)
        return fetch(`/integrations/slack/verify-challenge/${window.__challenge}/${code}`)
          .then(response => {
            if (!response.ok) {
              throw new Error(response.statusText)
            }
            response.json().then(function (data) {
              if ((data.error || ''.length >= 1)) {
                Swal.showValidationMessage('Error: ' + data.error || '')
              } else {
                Swal.fire({
                  title: 'All Set!',
                  // icon: 'success',
                  text: 'Slack has now been successfully setup!',
                  showConfirmButton: false,
                  allowEscapeKey: false,
                  allowOutsideClick: false,
                  allowEnterKey: false,
                  timer: 5000,
                  timerProgressBar: true,
                  imageUrl: 'https://c.tenor.com/2s44uADj69cAAAAi/parrot-slack.gif'
                }).then((result) => {
                  if (result.dismiss === Swal.DismissReason.timer) {
                    window.location = '/services?integrationComplete=slack'
                  }
                })
                setTimeout(function () {
                  window.location = '/services?integrationComplete=slack'
                }, 5250)
              }
            })
            return false
          })
          .catch(error => {
            setTimeout(function () {
              window._showSlackVerificationDialogue('Error')
            }, 250)
            return false
          })
      },
    }).then(function (result) {
      if (result.isConfirmed) {
        const value = result.value
        Swal.showValidationMessage(
          `Request failed: ${value.error}`
        )
      }
      return true
    })
  }, 1)
}
